import React from "react";
import NotificationSlider from "./NotificationSlider";

export default function DashboardTopSection() {
    return (
        <div className="grid xl:!grid-cols-6 !grid-cols-4 gap-4">

            {/* ================= LEFT ================= */}
            <div className="xl:!col-span-2 !col-span-4">
                <div
                    id="BLOCK_CUSTOMER_INFO"
                    event-block="BLOCK_CUSTOMER_INFO"
                    className="h-full"
                >
                    <div
                        className="w-full h-full p-2 px-3 relative min-w-[300px] rounded-[10px] overflow-hidden bg-center bg-no-repeat bg-cover"
                        style={{
                            background: "url('https://thuocsi.vn/images/bg-silver-1.png') 0% 0% / 100% 100%",
                        }}
                    >
                        <div className="flex flex-col justify-around gap-2 relative h-full">

                            {/* AVATAR */}
                            <div className="flex items-center gap-2">
                                <div className="group relative rounded-full min-w-[86px] w-[86px] h-[86px] overflow-hidden">
                                    <img
                                        src="https://gcs.buymed.com/thuocsi-live/images/2025d1ee085126dbc1346a31d7630126?quality=100"
                                        alt="Avatar"
                                        className="absolute inset-0 w-full h-full object-cover"
                                    />

                                    <div className="opacity-0 group-hover:opacity-100 transition-all absolute inset-0 flex items-center justify-center bg-black/50 rounded-full">
                                        <label
                                            htmlFor="avatar-upload"
                                            className="cursor-pointer h-full w-full flex items-center justify-center"
                                        >
                                            <svg
                                                className="MuiSvgIcon-root !text-white"
                                                viewBox="0 0 24 24"
                                            >
                                                <path d="M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z" />
                                            </svg>
                                        </label>
                                        <input
                                            id="avatar-upload"
                                            type="file"
                                            accept="image/png, image/jpeg"
                                            className="hidden"
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col gap-2">
                                    <p className="text-[16px] leading-[20px] font-semibold line-clamp-2">
                                        Nhà thuốc Vũ Huy
                                    </p>
                                </div>
                            </div>

                            {/* LEVEL */}
                            <div
                                className="flex flex-col gap-2 bg-white/30 p-2 rounded-[8px] border border-white"
                                style={{
                                    background: "url('https://thuocsi.vn/images/bg-silver-2.png') 0% 0% / 100% 100%",
                                }}
                            >
                                <div className="flex justify-between items-center">
                                    <img
                                        src="https://cdn-web-next.thuocsi.vn/images/level_new/sliver_new.svg"
                                        className="h-[32px]"
                                    />
                                    <p>
                                        <strong>0</strong> điểm
                                    </p>
                                </div>

                                <div className="w-full bg-white rounded-full overflow-hidden">
                                    <div
                                        className="bg-[var(--primary-color)] h-1 rounded-full"
                                        style={{ width: "0%" }}
                                    />
                                </div>

                                <div className="flex gap-1 items-center">
                                    <p>
                                        Mua thêm{" "}
                                        <span className="text-[var(--primary-color)] font-semibold">
                                            8.000.000đ
                                        </span>{" "}
                                        để thăng hạng
                                    </p>
                                    <a href="/users/loyalty_points?type=1" target="_blank">
                                        <img
                                            src="https://cdn-web-next.thuocsi.vn/images/level_new/gold_new.svg"
                                            className="w-[50px]"
                                        />
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* ================= RIGHT ================= */}
            <div className="col-span-4">
                <NotificationSlider />
            </div>

        </div>
    );
}
